import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout.tsx';
import Dashboard from './pages/Dashboard.tsx';
import ArticleAnalyzer from './pages/ArticleAnalyzer.tsx';
import Learning from './pages/Learning.tsx';
import Econometrics from './pages/Econometrics.tsx';
import Blogs from './pages/Blogs.tsx';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/article-analyzer" element={<ArticleAnalyzer />} />
          <Route path="/learning" element={<Learning />} />
          <Route path="/econometrics" element={<Econometrics />} />
          <Route path="/blogs" element={<Blogs />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App; 